const trackFunctionBlock = function (robotType, blockSeparator, categorySeparator){
    switch (robotType){
    case 'E6':
        return ``;
    case 'C1':
        return `
                <category
                    name="%{BKY_CATEGORY_TRACKFUNCTION}"
                    id="trackfunction"
                    colour="#005BAC"
                    secondaryColour="#0000FF">
                    <block type="trackfunction_speedcontrol">
                        <value name="LEFTSPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="RIGHTSPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_line_bmp">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_catch_line">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="LIGHT">
                            <shadow type="math_number">
                                <field name="NUM">14</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_turn_angle">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_go_bmp">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_goline">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_turnleft">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_turnright">
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_turn_w">
                        <value name="LEFTMOTOR">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="RIGHTMOTOR">
                            <shadow type="math_number">
                                <field name="NUM">40</field>
                            </shadow>
                        </value>
                        <value name="LIGHT">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="trackfunction_SetLightSensorThreshold">
                        <value name="PORT">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">2000</field>
                            </shadow>
                        </value>
                    </block>
                ${blockSeparator}
                ${categorySeparator}
                </category>
                `;
    default:
        return `
                <category
                    name="%{BKY_CATEGORY_TRACKFUNCTION}"
                    id="trackFunction"
                    colour="#005BAC"
                    secondaryColour="#0000FF">
                </category>
                `;
    }
};

export default trackFunctionBlock;
